export const XSD_STRING="xsd:string"
export const XSD_ANY_URI="xsd:anyURI"
export const XSD_NMTOKEN="xsd:NMTOKEN" // XML NMTOKENs
export const XSD_NAME="xsd:Name" // XML Names
export const XSD_NCNAME="xsd:NCName" // XML NCNames
//Encoded binary data
export const XSD_HEXBINARY="xsd:hexBinary" //Hex-encoded binary data
export const XSD_BASE64BINARY="xsd:base64Binary" //Base64-encoded binary data

// Limited-range integer numbers
export const XDD_HTML="xdd:html"
export const XSD_BYTE =  "xsd:byte" //  -128…+127 (8 bit) 
export const XSD_SHORT = "xsd:short" //    -32768…+32767 (16 bit) 
export const XSD_INT =  "xsd:int" //   -2147483648…+2147483647 (32 bit) |
export const XSD_LONG = "xsd:long" //    -9223372036854775808…+9223372036854775807 (64 bit) |
export const XSD_UNSINGNEDBYTE =  "xsd:unsignedByte"//    0…255 (8 bit) |
export const XSD_UNSIGNEDSHORT = "xsd:unsignedShort" //|    0…65535 (16 bit) |
export const XSD_UNSIGNEDINT = "xsd:unsignedInt" //|    0…4294967295 (32 bit) |
export const XSD_UNSIGNEDLONG = "xsd:unsignedLong"// |    0…18446744073709551615 (64 bit) |
export const XSD_POSITIVE_INTEGER="xsd:positiveInteger" // |    Integer numbers >0 |
export const XSD_NONNEGATIVEINTEGER = "xsd:nonNegativeInteger" // |    Integer numbers ≥0 |
export const XSD_NEGATIVEINTEGER = "xsd:negativeInteger" // |    Integer numbers <0 |
export const XSD_NONPOSITIVEINTEGER = "xsd:nonPositiveInteger" //Integer numbers ≤0
export const XDD_URL="xdd:url"
export const XSD_NORMALIZED_STRING="xsd:normalizedString"
export const XSD_TOKEN="xsd:NMTOKEN"
export const XSD_DECIMAL="xsd:decimal"
export const XSD_DOUBLE = "xsd:double"
export const XSD_FLOAT= "xsd:float"
export const XSD_INTEGER="xsd:integer"

// set input type to pattern numberic if placeholder is included in number array
export const NUMBER_ARRAY = [
  XDD_HTML,
  XSD_BYTE,
  XSD_SHORT,
  XSD_INT,
  XSD_LONG,
  XSD_UNSINGNEDBYTE,
  XSD_UNSIGNEDSHORT,
  XSD_UNSIGNEDINT,
  XSD_UNSIGNEDLONG,
  XSD_POSITIVE_INTEGER,
  XSD_NONNEGATIVEINTEGER,
  XSD_NEGATIVEINTEGER,
  XSD_NONPOSITIVEINTEGER,
  XSD_FLOAT,
  XSD_DOUBLE,
  XSD_DECIMAL,
  XSD_INTEGER
]


export const XSD_DATE_TIME="xsd:dateTime"
export const XSD_DATE_TIMESTAMP="xsd:dateTimeStamp"
export const XSD_G_YEAR= "xsd:gYear"
export const XSD_TIME= "xsd:time"
export const XSD_G_YEAR_MONTH= "xsd:gYearMonth"
export const XSD_G_YEAR_MONTH_DURACTION= "xsd:yearMonthDuration"
export const XSD_G_DAY_TIME_DURACTION= "xsd:dayTimeDuration"

export const XSD_G_MONTH= "xsd:gMonth"
export const XSD_G_MONTH_DAY= "xsd:gMonthDay"
export const XSD_G_DAY= "xsd:gDay"
export const XSD_TIME_DURATION= "xsd:duration"
export const XSD_DATE= "xsd:date"
export const XSD_BOOLEAN="xsd:boolean"
export const XSD_LANGUAGE="xsd:language"


export const RDF_LANGSTRING ="rdf:langString"
export const SYS_JSON_TYPE="sys:JSON"
export const SYS_UNIT_DATA_TYPE="sys:Unit"

export const MARKDOWN="markdown"


